import dataProvider from '@/api'

export default {
  /**
   * @description Получение vcp конфига
   *
   * @tutorial
   *
   * @param {object} payload
   *
   * @returns {object}
   */
  getVcpConfigNoAuth (payload = {}) {
    return dataProvider.post('/vcp-config-no-auth', payload)
  },
  getVcpConfig (payload = {}) {
    return dataProvider.post('/vcp-config', payload)
  },
  /**
   * @description Получение vcp конфига для первого блока
   *
   * @param {object} payload
   *
   * @returns {object}
   */
  getInitialVcpConfigNoAuth (payload = {}) {
    return dataProvider.post('/vcp-config-cut-no-auth', payload)
  },
  getInitialVcpConfig (payload = {}) {
    return dataProvider.post('/vcp-config-cut', payload)
  },
  /**
    * @description Список вопросов FAQ (работает и для не авторизованных, но нужно передавать город
    */
  getFAQ (payload = {}) {
    return dataProvider.get(`/faq/${payload.category}?brandId_H=${payload.brandId_H}&cityId=${payload.cityId}`)
  },
  /**
    * @description Список вопросов FAQ (работает и для не авторизованных, но нужно передавать город
    */
  getFAQNoAuth (payload = {}) {
    return dataProvider.get(`/faq-no-auth/${payload.category}?brandId_H=${payload.brandId_H}&cityId=${payload.cityId}`)
  },
}
